export type MerryDesktopShellMode = "canvas" | "content" | "workspace";
export type MerryDesktopShellSideDrawerVariant =
  | "default"
  | "store-overview"
  | "store-overview-with-chat";

export type MerryDesktopShellViewportBand =
  | "wide"
  | "desktop"
  | "compact";

export const merryDesktopShellGeometry = {
  gridGap: 12,
  leftNavigationWidth: 72,
  pageBlockEdge: 24,
  pageHorizontalEdge: 120,
  pageMaxWidth: 1200,
  panelCardWidth: 536,
  panelInlineMinWidth: 1440,
  panelReserveWidth: 560,
  panelRightEdge: 24,
  panelToolsGap: 12,
  panelToolsWidth: 48,
  sideDrawerLeft: 60,
  sideDrawerVerticalEdge: 24,
  sideDrawerWidth: 560,
  storeOverviewChatGap: 12,
  storeOverviewChatWidth: 536,
  storeOverviewCombinedWidth: 1836,
  storeOverviewDrawerWidth: 1288,
  topNavigationHeight: 72,
} as const;

export const merryDesktopShellFigmaNodeIds = {
  canvas: {
    compact: "645:99068",
    desktop: "645:99068",
    wide: "645:99068",
  },
  content: {
    compact: "572:58370",
    desktop: "572:57867",
    wide: "572:57360",
  },
  workspace: {
    compact: "759:153583",
    desktop: "759:153396",
    wide: "759:153208",
  },
} as const satisfies Record<
  MerryDesktopShellMode,
  Record<MerryDesktopShellViewportBand, string>
>;

export function getMerryDesktopShellViewportBand(
  viewportWidth: number,
): MerryDesktopShellViewportBand {
  if (viewportWidth >= 1920) {
    return "wide";
  }

  if (viewportWidth >= merryDesktopShellGeometry.panelInlineMinWidth) {
    return "desktop";
  }

  return "compact";
}

export function getMerryDesktopShellFigmaNodeId(
  mode: MerryDesktopShellMode,
  viewportWidth: number,
) {
  return merryDesktopShellFigmaNodeIds[mode][
    getMerryDesktopShellViewportBand(viewportWidth)
  ];
}

export function getMerryDesktopShellSourceNodeIds(
  mode: MerryDesktopShellMode,
) {
  return [...new Set(Object.values(merryDesktopShellFigmaNodeIds[mode]))].join(
    " ",
  );
}
